import { hasOnlyStudentLicenses } from '#shared/utils/license-scope'

export function useHasLicense() {
  const { loggedIn, user } = useUserSession()
  return computed(() => loggedIn.value && !!user.value?.licenses?.length)
}

/**
 * Checks licences for books, journals, academic articles and templates.
 * University lovkommentar packages do not cover these surfaces.
 */
export function useHasContentLicense() {
  const { loggedIn, user } = useUserSession()
  const { eanStudentRestricted } = useRuntimeConfig().public.licenses

  return computed(() => loggedIn.value && !!user.value?.licenses?.length && !hasOnlyStudentLicenses(user.value.licenses, eanStudentRestricted))
}
